module.exports = __webpack_public_path__ + "img/qr-code.9feb1f48.png";